export const PINCODE_MASTER_CACHE_KEY = 'getProductPincodes';

export const normalizePincodeInput = (value) =>
  String(value ?? '')
    .replace(/\D/g, '')
    .slice(0, 6);

const getItemPincode = (item) => item?.pincode ?? item?.pinCode ?? '';

export const extractPincodeLocationFromRecord = (record) => {
  if (!record || typeof record !== 'object') {
    return { pinCode: '', state: '', city: '' };
  }
  const pinCode = normalizePincodeInput(getItemPincode(record));
  const state = String(
    record.state ??
      record.stateName ??
      record.stateUT ??
      record.stateUt ??
      '',
  ).trim();
  const city = String(
    record.city ?? record.cityName ?? record.cityDistrict ?? '',
  ).trim();
  return { pinCode, state, city };
};

export const normalizeLocationToken = (value) =>
  String(value ?? '')
    .trim()
    .toLowerCase();

export const getStateNameFromRecord = (record) =>
  extractPincodeLocationFromRecord(record).state;

export const getCityNameFromRecord = (record) =>
  extractPincodeLocationFromRecord(record).city;

export const buildUniqueStateOptions = (items = []) => {
  const seen = new Map();
  for (const item of items) {
    const state = getStateNameFromRecord(item);
    if (!state) continue;
    const key = normalizeLocationToken(state);
    if (!seen.has(key)) {
      seen.set(key, { label: state, value: state });
    }
  }
  return Array.from(seen.values()).sort((a, b) =>
    a.label.localeCompare(b.label),
  );
};

export const buildUniqueCityOptionsForState = (items = [], stateName = '') => {
  const stateKey = normalizeLocationToken(stateName);
  if (!stateKey) return [];

  const seen = new Map();
  for (const item of items) {
    const itemState = getStateNameFromRecord(item);
    if (normalizeLocationToken(itemState) !== stateKey) continue;
    const city = getCityNameFromRecord(item);
    if (!city) continue;
    const key = normalizeLocationToken(city);
    if (!seen.has(key)) {
      seen.set(key, { label: city, value: city });
    }
  }
  return Array.from(seen.values()).sort((a, b) =>
    a.label.localeCompare(b.label),
  );
};

export const findPincodeRecordByStateAndCity = (items = [], state, city) => {
  const stateKey = normalizeLocationToken(state);
  const cityKey = normalizeLocationToken(city);
  if (!stateKey || !cityKey) return null;

  return (
    items.find((item) => {
      const location = extractPincodeLocationFromRecord(item);
      return (
        normalizeLocationToken(location.state) === stateKey &&
        normalizeLocationToken(location.city) === cityKey
      );
    }) ?? null
  );
};
